function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgTodasAsCategorias = function SvgTodasAsCategorias(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.714 9.507l-7.702 1.358a1.093 1.093 0 01-1.265-.887L8.39 2.277c-.169-.958.905-1.642 1.703-1.085l9.06 6.343c.797.559.521 1.803-.438 1.972zM5.625 21.879a5.375 5.375 0 100-10.75 5.375 5.375 0 000 10.75zm0-9.75a4.375 4.375 0 110 8.75 4.375 4.375 0 010-8.75zm7.813 9.405a1.25 1.25 0 01-1.014-1.449l1.304-7.393a1.25 1.25 0 011.448-1.013l7.392 1.303c.68.12 1.135.77 1.014 1.448l-1.303 7.393a1.251 1.251 0 01-1.448 1.014l-7.393-1.303zm7.856.115a.25.25 0 01-.29.203l-7.392-1.303a.25.25 0 01-.203-.29l1.303-7.393a.25.25 0 01.29-.203l7.393 1.304a.25.25 0 01.202.288l-1.303 7.394zM18.578 8.354a.093.093 0 01-.037.168L10.839 9.88a.093.093 0 01-.107-.076L9.374 2.103a.093.093 0 01.145-.092l9.059 6.343z",
    fill: props.color
  }));
};
SvgTodasAsCategorias.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgTodasAsCategorias.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgTodasAsCategorias;